import axios from 'axios'
import axiosplugin from './axios'

const CancelToken = axios.CancelToken;
let source = CancelToken.source();
const options = {
  responseType: 'text',
  timeout: 30000, 
  cancelToken: source.token
}

export default {
  cancelCall(){
    source.cancel('Operation canceled.');
    source = CancelToken.source();
  },  
  getProjects() {
    return new Promise(function (resolve,reject) {
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + "/api/projects",
       options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  getProject(id){
    return new Promise(function(resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + "/api/projects/"+id,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  getProjectEdit(id){
    return new Promise(function(resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + "/api/projects/"+id+"/edit",options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  getProjectFeedback(id){
    return new Promise(function(resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + "/api/projects/"+id+"/feedback",options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  postProjectFeedback(id, feedback){
    return new Promise(function(resolve,reject){
      axiosplugin.post( process.env.VUE_APP_CF_API_URL + "/api/feedbacks/"+id,feedback,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  editProjectFeedback(id,feedback){
    return new Promise(function(resolve,reject){
      axiosplugin.patch( process.env.VUE_APP_CF_API_URL + "/api/feedbacks/"+id, feedback,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  deleteProjectFeedback(idFeedback){
    return new Promise(function(resolve,reject){
      axiosplugin.delete( process.env.VUE_APP_CF_API_URL + "/api/feedbacks/"+idFeedback,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  getImage(id){
    return new Promise(function (resolve,reject) {
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + "/api/projects/images/"+ id, options)
      .then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    })
  },
  getCurrencies(){
    return new Promise(function (resolve,reject) {
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + "/api/projects/currencies", options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("Error getting currencies:  ",e)
        reject(e)
      })
    })
  },
  postProject(project){
    return new Promise(function (resolve,reject){
      axiosplugin.post( process.env.VUE_APP_CF_API_URL + '/api/projects', project ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    })
  },
  patchProject(project){
    return new Promise(function (resolve,reject){
      axiosplugin.patch( process.env.VUE_APP_CF_API_URL + '/api/projects/'+project.projectId, project ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  getFundingCampaigns(id){
    return new Promise(function(resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + "/api/fundingCampaigns/project/"+id,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
      })
    })
  },
  postFundingCampaign(campaign){
    return new Promise(function (resolve,reject){
      axiosplugin.post( process.env.VUE_APP_CF_API_URL + '/api/fundingCampaigns', campaign ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  getUserFinancialAccounts(){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/self' ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    })
  },
  getUserRole(){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/self/role', options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    })
  },
  approveProject(id){
    return new Promise(function (resolve,reject){
      axiosplugin.patch( process.env.VUE_APP_CF_API_URL + '/api/projects/'+id+'/approve' ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  setProjectForRevision(id){
    return new Promise(function (resolve,reject){
      axiosplugin.patch( process.env.VUE_APP_CF_API_URL + '/api/projects/'+id+'/revision' ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  publishProject(id){
    return new Promise(function (resolve,reject){
      axiosplugin.patch( process.env.VUE_APP_CF_API_URL + '/api/projects/'+id+'/publish' ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  postUser(user){
    return new Promise(function (resolve,reject){
      axiosplugin.post( process.env.VUE_APP_CF_API_URL + '/api/users', user ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  investProject(investment){
    return new Promise(function (resolve,reject){
      axiosplugin.patch( process.env.VUE_APP_CF_API_URL + '/api/transactions/invest', investment ,options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  //funding campaign
  getFundingCampaignsFor(projectId){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/fundingCampaigns/project/'+projectId+'/active',options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  closeFundingCampaign(fundingCampaignId){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/fundingCampaigns/'+fundingCampaignId+'/finish',options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  getCommissions(){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/transactions/commissions',options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  },
  getFinancialAccountForUser(userName){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/accounts/financial/user/'+userName, options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    })
  },
  payDividends(projectId, moneyAmount){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/transactions/payDividends/'+projectId+'?money='+moneyAmount, options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    })
  },
  getProjectTops(projectId){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/orders/'+projectId+'/tops', options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    })
  },
  createNewOrder(order){
    return new Promise(function (resolve,reject){
      if(!order.orderId){
        axiosplugin.post( process.env.VUE_APP_CF_API_URL + '/api/orders', order ,options).then((response) => {
          resolve(response)
        }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
        })
      } else {
        axiosplugin.post( process.env.VUE_APP_CF_API_URL + '/api/orders/'+order.orderId, order ,options).then((response) => {
          resolve(response)
        }).catch((e)=>{
          console.log("error: ",e)
          reject(e)
        })
      }
    }) 
  },
  resetDemo(){
    return axiosplugin.post(process.env.VUE_APP_CF_API_URL + '/api/demo/reset', {}, options)
  },
  getProjectsMarketInfo(){
    return new Promise(function (resolve,reject){
      axiosplugin.get( process.env.VUE_APP_CF_API_URL + '/api/projects/market', options).then((response) => {
        resolve(response)
      }).catch((e)=>{
        console.log("error: ",e)
        reject(e)
      })
    }) 
  }

}
